import { Box, styled } from "@mui/material";
import { APP_COLOR, APP_HOVER_COLOR, FONT_FAMILY } from "../../theme";

export const styles = {
  paymentComponentContainer: {
    padding: "15px 10px 15px 10px",
    height: "auto",
  } as const,
  billingContainer: {
    margin: "15px",
    height: "95vh",
    overflowY: "scroll",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  } as const,
  billingPageContainer: {
    margin: "20px 0 20px 0",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "30px",
  } as const,
  detailsContainer: {
    textAlign: "center",
    boxShadow: "0px 0px 40px rgba(0, 0, 0, 1)",
    width: "80%",
    padding: "25px",
    margin: "20px",
  } as const,
  paymentSuccessfulContainer: {
    display: "flex", 
    justifyContent: "center"
  } as const,
  button: {
    margin: "10px",
    "&:hover": {
      backgroundColor: "#1A8899",
    },
    width: "120px",
    color: "black",
    backgroundColor: "#27B6CB",
  } as const,
  billingButton: {
    fontFamily: FONT_FAMILY,
    textTransform: "none",
    fontSize: 16,
    width: 220,
    margin: "0px 10px 5px 5px",
    backgroundColor: APP_COLOR,
    ":hover": {
      backgroundColor: APP_HOVER_COLOR,
      color: "black",
    },
    color: "black",
    borderRadius: "var(--radius-md, 8px)",
  } as const,
  submitButton: {
    fontFamily: FONT_FAMILY,
    textTransform: "none",
    fontSize: 16,
    margin: "0px 10px 5px 10px",
    width: "40px",
    backgroundColor: APP_COLOR,
    ":hover": {
      backgroundColor: APP_HOVER_COLOR,
      color: "black",
    },
    color: "black",
    borderRadius: "var(--radius-md, 8px)",
  } as const,
  promoCodeInput: {
    "& .MuiInputBase-input": {
      height: "10px",
      width: "110px",
    },
  } as const,
  paymentFailedBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "content",
    textAlign: "center",
    height: "62vh",
    width: "full",
  } as const,
  paymentFailedHeading: {
    width: "100%", 
    textAlign: "center"
  } as const,
};

export const PlansDetailsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flex: "wrap",
  justifyContent: "space-between",
  padding: "15px",
  gap: "20px",
  textAlign: "left",
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

export const SubscriptionHeaderBox = styled(Box)(({ theme }) => ({
  fontFamily: FONT_FAMILY,
  fontSize: "24px",
  fontWeight: "bold",
  textAlign: "center",
  textOverflow: "wrap",
  [theme.breakpoints.down("sm")]: {
    fontSize: "18px",
  },
}));

export const AccordionContainer = styled(Box)(({ theme }) => ({
  marginBottom: "20px",
  [theme.breakpoints.up("sm")]: {
    display: "none",
  },
}));

export const TopContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
  },
}));
